import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Row,
  Table,
} from 'reactstrap';
import dayjs from 'dayjs';
import { Airplay, Clock, User, MapPin, Video } from 'react-feather';
import {
  OPTION_EVENT_USER,
  UNIT_TYPE,
  USER_EVENT_TYPE,
  USER_ROLES,
  USER_ROOM_STATUS,
  EVENT_LIVE_TRAINING_STATUS,
  COURSE_STATUS,
} from 'constants/constants';
import ButtonDropdownCustom from 'components/CustomButton/ButtonDropdownCustom';
import { Spin } from 'antd';
import { openRecorded } from 'store/modal/index';
import { useUnit } from 'hooks/units/index';
import { useUser, useViewMode } from 'hooks/index';
import styles from 'styles/Unit.module.scss';
import {
  formatHHmmDDMMYYYY,
  getTimeFromDate,
  titleExtensionWithTimeZone,
} from 'helpers/format-time';
import classnames from 'classnames';
import ModalDetail from './ModalDetail';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import getMonitorUrl from 'helpers/monitoring';
import { getColor, getColorText } from 'store/settings';
const ZoomApp = dynamic(() => import('./zoomInside'), {
  ssr: false,
});

const EventItem = ({
  event,
  onRegister,
  onUnregister,
  onJoinRoom,
  isLoading,
  onAttendance,
  waittime,
}) => {
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const dispatch = useDispatch();
  const unitSelected = useUnit();
  const viewMode = useViewMode();
  const user = useUser();
  const { asPath } = useRouter();
  const [instructorTitles, setInstructorTitles] = useState();
  const [importTitle, setImportTitle] = useState('');
  const [isLiving, setLiving] = useState(false);
  const [zoom, setZoom] = useState(false);
  const [isViewHistories, setIsViewHostories] = useState('');
  const [historyLive, setHistoryLive] = useState([]);
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  function handleCloseModal() {
    setIsViewHostories('');
  }
  async function onViewHistories(id) {
    setIsViewHostories(id);
  }

  const zoomHandler = () => {
    getMonitorUrl(user, viewMode, `${asPath}?isLive`);
    setZoom(true);
  };

  const nth = (getdate) => {
    if (getdate > 3 && getdate < 21) return 'th';
    switch (getdate % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const dateConversion = (startdate) => {
    var date_time = new Date(startdate);
    let dayOfWeekNumber = date_time.getDay();
    let getdate = date_time.getDate();
    let nameOfDay;
    var month = date_time.toLocaleString('default', { month: 'long' });

    switch (dayOfWeekNumber) {
      case 0:
        nameOfDay = 'Sunday';

        break;
      case 1:
        nameOfDay = 'Monday';

        break;
      case 2:
        nameOfDay = 'Tuesday';

        break;
      case 3:
        nameOfDay = 'Wednesday';

        break;
      case 4:
        nameOfDay = 'Thursday';

        break;
      case 5:
        nameOfDay = 'Friday';

        break;
      case 6:
        nameOfDay = 'Saturday';

        break;
    }

    var hours = date_time.getHours();
    var minutes = date_time.getMinutes();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = `${hours}:${minutes}${ampm}`;
    let date_conversation = {
      nameOfDay: nameOfDay,
      getdate: getdate,
      nth: nth(getdate),
      month: month,
      strTime: strTime,
    };

    return date_conversation;
  };

  const instructorName = () => {
    if (event?.instructor?.length) {
      let array = [...event?.instructor];
      let name;
      array?.map((dt) => {
        name = name ? name + ',  ' + dt?.fullName : dt?.fullName;
      });
      setInstructorTitles(name);
    }
  };

  useEffect(() => {
    const timeStart = new Date(event.time?.begin);
    const timeEnd = new Date(event.time?.end);
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnd);
    if (event.importLesson === true) {
      let title = `${event.name} (${event.unit?.course?.code})  ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.nameOfDay} ${time_End.getdate}${time_End.nth} ${time_End.month} ${time_End.strTime}`;
      setImportTitle(title);
    }
    instructorName();
  }, [event]);

  const listInfo = [
    {
      icon: <Airplay />,
      label: 'SESSION',
      value:
        (event?.type == 'WEBINAR' || event?.type == UNIT_TYPE.LIVESTREAMING) &&
        event?.titleExtenstion
          ? event?.name +
            ' ' +
            titleExtensionWithTimeZone(
              event?.time?.begin,
              event?.time?.end,
              event?.time?.timezone,
            )
          : (event?.type == 'WEBINAR' ||
              event?.type == UNIT_TYPE.LIVESTREAMING) &&
            event?.importLesson === true
          ? importTitle
          : event?.name,
    },
    {
      icon: <Clock />,
      label: 'TIME',
      value:
        event?.time?.begin && event?.time?.end
          ? getTimeFromDate(event?.time?.begin) +
            '-' +
            getTimeFromDate(event?.time?.end)
          : '-',
    },
    {
      icon: <MapPin />,
      label: 'LOCATION',
      value:
        event?.type === USER_EVENT_TYPE.CLASSROOM ? (
          <span>
            {event?.location?.name}{' '}
            <i>
              (capacity:
              {event?.location?.capacity})
            </i>
          </span>
        ) : (
          ''
        ),
    },
    {
      icon: <User />,
      label: 'INSTRUCTOR',
      value: instructorTitles,
    },
    {
      icon: <MapPin />,
      label: 'LOCATION MASTER',
      value: event?.locationMaster?.locationName,
    },
  ];

  useEffect(() => {
    const living =
      event?.roomStatus === USER_ROOM_STATUS.RUNNING ? true : false;
    setLiving(living);
  }, [event]);

  useEffect(() => {
    setHistoryLive(event?.liveDetails);
  }, [event?.liveDetails]);

  return (
    <Spin spinning={zoom} size="large">
      <Card style={{ zIndex: 1 }}>
        <CardBody>
          <div>
            <h5 className="text-center lesson-label-tittle">
              {(event?.type == 'WEBINAR' ||
                event?.type == UNIT_TYPE.LIVESTREAMING) &&
              event?.titleExtenstion
                ? event?.name +
                  ' ' +
                  titleExtensionWithTimeZone(
                    event?.time?.begin,
                    event?.time?.end,
                    event?.time?.timezone,
                  )
                : (event?.type == 'WEBINAR' ||
                    event?.type == UNIT_TYPE.LIVESTREAMING) &&
                  event?.importLesson === true
                ? importTitle
                : event?.name}
              {isLiving ? (
                <Badge color="light-danger" className="ml-05">
                  Online
                </Badge>
              ) : null}
            </h5>
            <hr />
            <div className="w-100">
              <div className="d-flex align-items-center">
                <Button.Ripple className={styles.dayCircle}>
                  <p className="mb-0">
                    {dayjs(event?.time?.begin).format('DD')}
                  </p>
                  <p className="mb-0">
                    {dayjs(event?.time?.begin).format('MMM')}
                  </p>
                </Button.Ripple>
                <div className="flex-fill ml-5" style={{ width: 0 }}>
                  {listInfo.map((item, index) => {
                    if (!item.value) {
                      return;
                    }

                    return (
                      <Row key={index} className="mb-1">
                        <Col sm={1} style={{ color: '#8E96AA' }}>
                          {item.icon}
                        </Col>
                        <Col sm={11}>
                          <p className="mb-0 lesson-label-tittle">
                            {item.label}
                          </p>
                          <p className="mb-0 text-break view-page-name">
                            {item.value}
                          </p>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
              </div>
              {Array.isArray(historyLive) && historyLive?.length ? (
                <div>
                  <h3 className="sub-heading_text_title">
                    Online training history
                  </h3>
                  <div className="overflow-auto">
                    <Table responsive>
                      <thead className="thead-light">
                        <tr>
                          <th>No.</th>
                          <th>Start time</th>
                          <th>End time</th>
                          <th>Account</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historyLive?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {item?.startTime
                                ? formatHHmmDDMMYYYY(item?.startTime)
                                : null}
                            </td>
                            <td>
                              {item?.endTime
                                ? formatHHmmDDMMYYYY(item?.endTime)
                                : null}
                            </td>
                            <td>{item?.account}</td>
                            <td>
                              <Badge
                                color={`light-${
                                  !item?.endTime &&
                                  item?.status ===
                                    EVENT_LIVE_TRAINING_STATUS.LIVING
                                    ? 'danger'
                                    : 'secondary'
                                }`}
                              >
                                {!item?.endTime &&
                                item?.status ===
                                  EVENT_LIVE_TRAINING_STATUS.LIVING
                                  ? 'Online'
                                  : 'Stop'}
                              </Badge>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-center flex-wrap">
                      <Button.Ripple
                        className="round mx-05 mt-05"
                        color="dark"
                        size="sm"
                        outline
                        onClick={() => onViewHistories(event._id)}
                      >
                        ---
                      </Button.Ripple>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </CardBody>
        <CardFooter className="d-flex justify-content-center flex-wrap">
          {event?.recorded?.length > 0 &&
            (user?.userType?.includes('Recordings') ||
              viewMode === USER_ROLES.CENTRE_ADMIN) && (
              <button
                className={classnames(
                  'btn-bg-color mx-05 mt-05',
                  styles['custom-btn-recorded'],
                )}
                onClick={() =>
                  dispatch(
                    openRecorded({
                      data: event?.recorded,
                      title:
                        (event?.type == 'WEBINAR' ||
                          event?.type == UNIT_TYPE.LIVESTREAMING) &&
                        event?.titleExtenstion
                          ? event?.name +
                            ' ' +
                            titleExtensionWithTimeZone(
                              event?.time?.begin,
                              event?.time?.end,
                              event?.time?.timezone,
                            )
                          : (event?.type == 'WEBINAR' ||
                              event?.type == UNIT_TYPE.LIVESTREAMING) &&
                            event?.importLesson === true
                          ? importTitle
                          : event?.name,
                    }),
                  )
                }
                style={{
                  backgroundColor: `${colorStatus}`,
                  color: `${colorTextStatus}`,
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = colorStatus;
                  e.target.style.color = colorStatus;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = colorStatus;
                  e.target.style.color = colorTextStatus;
                }}
              >
                Recorded
              </button>
            )}

          {!event?.isInstructor && event?.userRole === 'LEARNER' && (
            <div className="mt-05">
              {event?.optionUser == OPTION_EVENT_USER.REGISTRY ? (
                event?.registered ? (
                  <ButtonDropdownCustom
                    title="Registered"
                    disabledBtn
                    disabledMenu={
                      [OPTION_EVENT_USER.ALL, OPTION_EVENT_USER.CUSTOM].indexOf(
                        event?.optionUser,
                      ) !== -1
                    }
                    actions={[
                      {
                        text: 'Unregister',
                        action: () => onUnregister(event?.sessionUserId),
                      },
                    ]}
                    disabled={isLoading || isDisabled}
                  />
                ) : (
                  <button
                    className="btn-bg-color mx-05"
                    onClick={() =>
                      onRegister(event?._id, event?.accessCodeRequired)
                    }
                    disabled={
                      isLoading ||
                      event?.optionUser !== OPTION_EVENT_USER.REGISTRY ||
                      isDisabled
                    }
                    style={{
                      backgroundColor: `${colorStatus}`,
                      color: `${colorTextStatus}`,
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'white';
                      e.target.style.borderColor = colorStatus;
                      e.target.style.color = colorStatus;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = colorStatus;
                      e.target.style.color = colorTextStatus;
                    }}
                  >
                    Register
                  </button>
                )
              ) : null}
            </div>
          )}

          {unitSelected?.type === UNIT_TYPE.LIVESTREAMING &&
            (event?.userRole === 'LEARNER' ||
              viewMode === USER_ROLES.CENTRE_ADMIN) && (
              <>
                {(viewMode === USER_ROLES.LEARNER ||
                  viewMode === USER_ROLES.CENTRE_ADMIN) &&
                  !metaData?.zoomInside && (
                    <button
                      disabled={
                        (isLiving
                          ? viewMode === USER_ROLES.CENTRE_ADMIN
                            ? false
                            : !event?.registered
                          : true) || isDisabled
                      }
                      className={classNames(
                        isLiving ? styles['btn-bg-color'] : '',
                        'btn-bg-color mx-05 mt-05',
                      )}
                      style={{
                        backgroundColor: `${colorStatus}`,
                        color: `${colorTextStatus}`,
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'white';
                        e.target.style.borderColor = colorStatus;
                        e.target.style.color = colorStatus;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = colorStatus;
                        e.target.style.color = colorTextStatus;
                      }}
                      onClick={() =>
                        onJoinRoom(event._id, event?.accessCodeRequired)
                      }
                    >
                      {/* {isLiving ? <Video size={14} /> : null} */}
                      {isLiving ? <>{waittime}</> : 'Join Room'}
                    </button>
                  )}

                {metaData?.zoomInside
                  ? zoom
                    ? !event?.isInstructor &&
                      event?.registered !== false && (
                        <ZoomApp
                          event={event.unit}
                          id={event._id}
                          isLiving={isLiving}
                          disabled={isLoading}
                        />
                      )
                    : viewMode === USER_ROLES.LEARNER && (
                        <button
                          disabled={isLoading || !isLiving || isDisabled}
                          className={classNames(
                            isLiving ? styles['btn-bg-color'] : '',
                            'btn-bg-color mx-05 mt-05',
                          )}
                          onClick={zoomHandler}
                          style={{
                            backgroundColor: `${colorStatus}`,
                            color: `${colorTextStatus}`,
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = 'white';
                            e.target.style.borderColor = colorStatus;
                            e.target.style.color = colorStatus;
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = colorStatus;
                            e.target.style.color = colorTextStatus;
                          }}
                        >
                          <>Join Room</>
                        </button>
                      )
                  : null}
              </>
            )}

          {(event?.isInstructor || event?.userRole === 'INSTRUCTOR') && (
            <>
              {unitSelected?.type === UNIT_TYPE.LIVESTREAMING &&
                viewMode !== USER_ROLES.LEARNER &&
                viewMode !== USER_ROLES.CENTRE_ADMIN &&
                !metaData?.zoomInside && (
                  <button
                    disabled={isLoading || isDisabled}
                    className={classNames(
                      isLiving ? styles['btn-bg-color'] : '',
                      'btn-bg-color mx-05 mt-05',
                    )}
                    style={{
                      backgroundColor: `${colorStatus}`,
                      color: `${colorTextStatus}`,
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'white';
                      e.target.style.borderColor = colorStatus;
                      e.target.style.color = colorStatus;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = colorStatus;
                      e.target.style.color = colorTextStatus;
                    }}
                    onClick={() => onJoinRoom(event._id)}
                  >
                    {/* {isLiving ? <Video size={14} /> : null} */}
                    {isLiving ? <>Join Room</> : 'Start Room'}
                  </button>
                )}
              {metaData?.zoomInside
                ? zoom
                  ? unitSelected?.type === UNIT_TYPE.LIVESTREAMING && (
                      <ZoomApp
                        event={event.unit}
                        id={event._id}
                        isLiving={isLiving}
                        disabled={isLoading}
                      />
                    )
                  : viewMode !== USER_ROLES.LEARNER &&
                    viewMode !== USER_ROLES.CENTRE_ADMIN &&
                    unitSelected?.type === UNIT_TYPE.LIVESTREAMING && (
                      <button
                        disabled={isLoading || isDisabled}
                        className={classNames(
                          isLiving ? styles['btn-bg-color'] : '',
                          'btn-bg-color mx-05 mt-05',
                        )}
                        onClick={zoomHandler}
                        style={{
                          backgroundColor: `${colorStatus}`,
                          color: `${colorTextStatus}`,
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'white';
                          e.target.style.borderColor = colorStatus;
                          e.target.style.color = colorStatus;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = colorStatus;
                          e.target.style.color = colorTextStatus;
                        }}
                      >
                        {isLiving ? <>Join Room</> : <>Start Room</>}
                      </button>
                    )
                : null}

              {viewMode !== USER_ROLES.LEARNER &&
                viewMode !== USER_ROLES.CENTRE_ADMIN && (
                  <Button.Ripple
                    className="round mx-05 mt-05"
                    color="info"
                    onClick={() => onAttendance(event._id)}
                    disabled={isLoading || isDisabled}
                  >
                    Attendance
                  </Button.Ripple>
                )}
            </>
          )}
        </CardFooter>
        {isViewHistories ? (
          <ModalDetail
            open={true}
            toggle={handleCloseModal}
            data={isViewHistories}
          />
        ) : null}
      </Card>
    </Spin>
  );
};

EventItem.propTypes = {
  event: PropTypes.object.isRequired,
  onRegister: PropTypes.func.isRequired,
  onUnregister: PropTypes.func.isRequired,
  onJoinRoom: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onAttendance: PropTypes.func.isRequired,
  waittime: PropTypes.func.isRequired,
};

export default EventItem;
